import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { ROLES, getRoleName } from '../utils/roleConstants';

const normalizeRoleId = (rawRole) => {
  if (rawRole === null || rawRole === undefined) return null;

  const numericRole = Number(rawRole);
  if (!Number.isNaN(numericRole) && numericRole > 0) {
    return numericRole;
  }

  const roleText = String(rawRole).toLowerCase().trim();
  if (roleText.includes('admin')) return ROLES.ADMIN;
  if (roleText.includes('teacher') || roleText.includes('profesor')) return ROLES.TEACHER;
  if (roleText.includes('student') || roleText.includes('estudiante')) return ROLES.STUDENT;

  return null;
};

export const useUsuarioWithRole = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useUsuarioWithRole debe usarse dentro de un AuthProvider');
  }
  
  const usuarioConCedula = context.usuarioConCedula;
  const roleId =
    normalizeRoleId(usuarioConCedula?.roleId) ??
    normalizeRoleId(usuarioConCedula?.role?.id) ??
    normalizeRoleId(usuarioConCedula?.rol) ??
    normalizeRoleId(usuarioConCedula?.role) ??
    normalizeRoleId(usuarioConCedula?.role?.name) ??
    normalizeRoleId(context.user?.roleId) ??
    normalizeRoleId(context.user?.rol) ??
    normalizeRoleId(context.user?.role) ??
    normalizeRoleId(context.user?.roles?.[0]) ??
    null;
  
  return {
    // Datos del usuario
    usuarioConCedula,
    roleId,
    roleName: getRoleName(roleId),
    
    // Verificaciones de rol
    isAdmin: roleId === ROLES.ADMIN,
    isTeacher: roleId === ROLES.TEACHER,
    isStudent: roleId === ROLES.STUDENT,
    
    // Estados
    isLoading: context.isLoadingUsuario,
    error: context.errorUsuario,
    
    // Funciones
    refresh: context.refreshUsuarioConCedula,
    setUsuarioConCedula: context.setUsuarioConCedula,
    
    // Funciones helper
    hasRole: (expectedRoleId) => roleId === expectedRoleId,
    hasAnyRole: (expectedRoleIds) => expectedRoleIds.includes(roleId),
    isAdminOrTeacher: roleId === ROLES.ADMIN || roleId === ROLES.TEACHER,
  };
}; 